import { disallowInsecureCharacters, required } from '@seek/validators-js';
import { TextField } from 'braid-design-system';
import React from 'react';

import { mapBraidFieldProps } from 'src/utils/mapBraidFieldProps';

import { useField } from '../formState';

const FirstNameField = () => {
  const firstName = useField({
    id: 'firstName',
    validators: [required, disallowInsecureCharacters],
  });

  return (
    <TextField
      id="first-name-field"
      autoFocus
      label="First name"
      {...mapBraidFieldProps(firstName)}
    />
  );
};

export default FirstNameField;
